import { Menu } from '../common/menu/menu.js';

/**
 * @typedef {keyof typeof MENU_OPTIONS} MenuOptions
 */

/** @enum {MenuOptions} */
export const MENU_OPTIONS = Object.freeze({
  MONSTERDEX: 'MONSTERDEX',
  MONSTERS: 'MONSTERS',
  BAG: 'BAG',
  QUESTS: 'QUESTS',
  CARDSHOP: 'CARDSHOP',
  MARKET: 'MARKET',
  MAP: 'MAP',
  ARENA: 'ARENA',
  PROFILE: 'PROFILE',
  SETTINGS: 'SETTINGS',
  SAVE: 'SAVE',
  EXIT: 'EXIT',
});

export class WorldMenu extends Menu {
  /**
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene, [
      MENU_OPTIONS.MONSTERS,
      MENU_OPTIONS.BAG,
      MENU_OPTIONS.QUESTS,
      MENU_OPTIONS.CARDSHOP,
      MENU_OPTIONS.MARKET,
      MENU_OPTIONS.MAP,
      MENU_OPTIONS.ARENA,
      MENU_OPTIONS.PROFILE,
      MENU_OPTIONS.SETTINGS,
      MENU_OPTIONS.SAVE,
      MENU_OPTIONS.EXIT,
    ]);
  }
}
